const gamePlay = [
    // Level 1
    {
        id: 1,
        Question: "Which sport are you gearing up to play?",
        Answers: [
            { response: "Pickleball", icon: "Pickle.png", goTo: 2 },
            { response: "Padel", icon: "Padel.png", goTo: 17 },
            { response: "Table Tennis", icon: "TableTennis.png", goTo: 28 },
        ],
    },

    // Pickleball branch
    {
        id: 2,
        Question: "Have you played Pickleball before?",
        Answers: [
            { response: "Yes", text: "You've already got a feel for the game. We'll dial in the gear that keeps up with your growth.", icon: "#Yes_have_you_played_before", goTo: 3 },
            { response: "No", text: "New here? Let's get you equipped to start strong.", icon: "#No_have_you_played_before", goTo: 12 },
        ],
    },
    {
        id: 3,
        Question: "How long have you been playing the sport?",
        Answers: [
            { response: "<1  month", text: "Just getting started!.", icon: "#Less_than_one__month", goTo: 4 },
            { response: "1-3 months", text: "You've caught the bug. Let's find what helps you level up!", icon: "#one_to_three_months", goTo: 4 },
            { response: ">3 months", text: "You're in it for the long game. Let's get serious.", icon: "#more_than_three_months", goTo: 4 },
        ],
    },
    {
        id: 4,
        Question: "What level of play are you at?",
        key: "Skill",
        Answers: [
            { response: "Beginner", text: "Here to learn. We've got your back.", icon: "#Beginner", goTo: 5 },
            { response: "Intermediate", text: "You're getting sharper — let's dial in your gear.", icon: "#Intermediate", goTo: 6 },
            { response: "Advanced", text: "You know your shots. Let's help you control the game.", icon: "#Advanced", goTo: 11 },
        ],
    },
    {
        id: 5,
        Question: "What are you looking to achieve with your new racket?",
        key: "Achievement",
        Answers: [
            { response: "Casual play", text: "Just here to have fun!", icon: "#Casual_play_pickleball", goTo: 7 },
            { response: "Level up", text: "Ready to raise your game? Let's go!", icon: "#Level_up_beginner", goTo: 8 },
        ],
    },
    {
        id: 6,
        Question: "What are you looking to achieve with your new racket?",
        key: "Achievement",
        Answers: [
            { response: "Gear change", text: "Need a backup or second paddle", icon: "#Gear_change", goTo: 9 },
            { response: "Level up", text: "Looking to upgrade. Time for an edge that keeps up with your game.", icon: "#Level_up_intermediate", goTo: 10 },
        ],
    },
    {
        id: 7,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "StrikeBase" },
            { response: "Speed", text: "Quick on your feet? We'll match that momentum", icon: "#Speed", goTo: "StrikeBase" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "MaxStrike,Veloflex" },
        ],
    },
    {
        id: 8,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "AeroFusion,MaxStrike" },
            { response: "Speed", text: "Quick on your feet? We'll match that momentum", icon: "#Speed", goTo: "Aero,Velo" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Velo" },
        ],
    },
    {
        id: 9,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "AeroFusion,MaxStrike" },
            { response: "Speed", text: "Quick on your feet? We'll match that momentum", icon: "#Speed", goTo: "Aero,Velo" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Velo" },
        ],
    },
    {
        id: 10,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "AeroFusion,HyperCharge" },
            { response: "Speed", text: "Quick on your feet? We'll match that momentum", icon: "#Speed", goTo: "AeroFusion,HyperCharge" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "HyperCharge" },
        ],
    },
    {
        id: 11,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "UltraVolt_14mm,HyperCharge" },
            { response: "Speed", text: "Quick on your feet? We'll match that momentum", icon: "#Speed", goTo: "AeroFusion,UltraVolt_14mm" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "UltraVolt_16mm,HyperCharge" },
        ],
    },
    {
        id: 12,
        Question: "Have you played any other racquet sport before — like tennis, badminton, or squash?",
        Answers: [
            { response: "Yes", text: "Awesome. Your instincts will kick in — now let's match the gear.", icon: "#Yes_other_racket_sports", goTo: 13 },
            { response: "No", text: "No worries. Everyone starts somewhere — let's build from the basics.", icon: "#No_other_racket_sports", goTo: 14 },
        ],
    },
    {
        id: 13,
        Question: "What's your skill level in racket sports you've played before?",
        key: "Skill",
        Answers: [
            { response: "Beginner", text: "Here to learn. We've got your back.", icon: "#Beginner", goTo: 15 },
            { response: "Intermediate", text: "You're getting sharper — let's dial in your gear.", icon: "#Intermediate", goTo: 16 },
            { response: "Advanced", text: "You know your shots. Let's help you control the game.", icon: "#Advanced", goTo: 16 },
        ],
    },
    {
        id: 14,
        Question: "What's motivating you to start playing Pickleball?",
        Answers: [
            { response: "Looking to play casually", icon: "#Casual_play_pickleball", goTo: "StrikeBase" },
            { response: "Learn and start investing into a  sport - pickleball", icon: "#Level_up_intermediate", goTo: "Veloflex,MaxStrike" },
        ],
    },
    {
        id: 15,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "StrikeBase" },
            { response: "Speed", text: "Quick on your feet? We'll match that momentum", icon: "#Speed", goTo: "StrikeBase" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Veloflex,MaxStrike" },
        ],
    },
    {
        id: 16,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "UltraVolt_14mm,HyperCharge" },
            { response: "Speed", text: "Quick on your feet? We'll match that momentum", icon: "#Speed", goTo: "AeroFusion,Veloflex" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Veloflex" },
        ],
    },

    // Padel branch
    {
        id: 17,
        Question: "Have you played paddle before?",
        Answers: [
            { response: "Yes", text: "You've already got a feel for the game. We'll dial in the gear that keeps up with your growth.", icon: "#Yes_have_you_played_before", goTo: 18 },
            { response: "No", text: "Padel-curious? Let's get you equipped.", icon: "#No_have_you_played_before", goTo: 23 },
        ],
    },
    {
        id: 18,
        Question: "How long have you been playing Padel Tennis?",
        Answers: [
            { response: "<1  month", text: "A fresh start. Let's set you up right", icon: "#Less_than_one__month", goTo: 19 },
            { response: "1-3 months", text: "Settling in? Let's find what clicks.", icon: "#one_to_three_months", goTo: 19 },
            { response: ">3 months", text: "You've built your base. Time to refine.", icon: "#more_than_three_months", goTo: 19 },
        ],
    },
    {
        id: 19,
        Question: "What level of play are you at?",
        key: "Skill",
        Answers: [
            { response: "Beginner", text: "Learning the ropes? We'll handle the rest.", icon: "#Beginner", goTo: 20 },
            { response: "Intermediate", text: "You've got rhythm - now let's build precision.", icon: "#Intermediate", goTo: 21 },
            { response: "Advanced", text: "Let's elevate your edge.", icon: "#Advanced", goTo: 22 },
        ],
    },
    {
        id: 20,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "Equinex" },
            { response: "Balance", text: "A bit of everything - let's keep it versatile.", icon: "#Balance", goTo: "Equinex" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Kinex" },
        ],
    },
    {
        id: 21,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "Dynamex" },
            { response: "Balance", text: "A bit of everything - let's keep it versatile.", icon: "#Balance", goTo: "Equinex" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Kinex,Equinex" },
        ],
    },
    {
        id: 22,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "Dynamex" },
            { response: "Balance", text: "A bit of everything - let's keep it versatile.", icon: "#Balance", goTo: "Dynamex" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Equinex" },
        ],
    },
    {
        id: 23,
        Question: "Have you played any other racquet sport before — like tennis, badminton, or squash?",
        Answers: [
            { response: "Yes", text: "Awesome. Your instincts will kick in - we'll match you with the right gear", icon: "#Yes_other_racket_sports", goTo: 27 },
            { response: "No", text: "We'll keep things simple and focused.", icon: "#No_other_racket_sports", goTo: 26 },
        ],
    },
    {
        id: 27,
        Question: "What's your skill level in racket sports you've played before?",
        key: "Skill",
        Answers: [
            { response: "Beginner", text: "Learning the ropes? We'll handle the rest.", icon: "#Beginner", goTo: 24 },
            { response: "Intermediate", text: "You've got rhythm - now let's build precision.", icon: "#Intermediate", goTo: 25 },
            { response: "Advanced", text: "Let's elevate your edge.", icon: "#Advanced", goTo: 25 },
        ],
    },
    {
        id: 24,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "Equinex" },
            { response: "Balance", text: "A bit of everything - let's keep it versatile.", icon: "#Balance", goTo: "Equinex" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Kinex" },
        ],
    },
    {
        id: 25,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Power", text: "You bring the heat. Let's amplify it.", icon: "#Power", goTo: "Dynamex" },
            { response: "Balance", text: "A bit of everything - let's keep it versatile.", icon: "#Balance", goTo: "Equinex" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone", icon: "#Control", goTo: "Kinex,Equinex" },
        ],
    },
    {
        id: 26,
        Question: "How familiar are you with Padel as a sport?",
        Answers: [
            { response: "New here, tell me more", text: "We'll set you up with a solid first paddle and a quick guide so you're ready to rally.", icon: "#I_dont_know_much_padel", goTo: "Kinex", blog: "padel-playbook" },
            { response: "I know the basics", text: "Perfect - let's match you with gear that brings out your best.", icon: "#I_know_the_basics_padel", goTo: "Kinex" },
        ],
    },

    // Table Tennis branch
    {
        id: 28,
        Question: "Have you played Table Tennis before?",
        Answers: [
            { response: "Yes", text: "You've already got a feel for the game. We'll dial in the gear that keeps up with your growth.", icon: "#Yes_have_you_played_before", goTo: 29 },
            { response: "No", text: "New here? Let's get you equipped to start strong.", icon: "#No_have_you_played_before", goTo: 34 },
        ],
    },
    {
        id: 29,
        Question: "How long have you been playing Table Tennis?",
        Answers: [
            { response: "<6 months", text: "Just getting started!", icon: "#Less_than_six_months", goTo: 30 },
            { response: "6-18 months", text: "You've caught the bug. Let's find what helps you level up!", icon: "#six_to_eighteen_months", goTo: 37 },
            { response: ">18 months", text: "You're in it for the long game. Let's get serious.", icon: "#more_than_eighteen_months", goTo: 38 },
        ],
    },
    // <6 months skill level
    {
        id: 30,
        Question: "What level of play are you at?",
        key: "Skill",
        Answers: [
            { response: "Beginner", text: "Here to learn. We've got your back.", icon: "#Beginner", goTo: "RiftX" },
            { response: "Intermediate", text: "You're getting sharper — let's dial in your gear.", icon: "#Intermediate", goTo: 31 },
            { response: "Advanced", text: "You know your shots. Let's help you control the game.", icon: "#Advanced", goTo: "Apex,StormX" },
        ],
    },
    // 6-18 months skill level
    {
        id: 37,
        Question: "What level of play are you at?",
        key: "Skill",
        Answers: [
            { response: "Beginner", text: "Here to learn. We've got your back.", icon: "#Beginner", goTo: "RiftX" },
            { response: "Intermediate", text: "You're getting sharper — let's dial in your gear.", icon: "#Intermediate", goTo: 31 },
            { response: "Advanced", text: "You know your shots. Let's help you control the game.", icon: "#Advanced", goTo: "StormX" },
        ],
    },
    // >18 months skill level
    {
        id: 38,
        Question: "What level of play are you at?",
        key: "Skill",
        Answers: [
            { response: "Beginner", text: "Here to learn. We've got your back.", icon: "#Beginner", goTo: "RiftX" },
            { response: "Intermediate", text: "You're getting sharper — let's dial in your gear.", icon: "#Intermediate", goTo: 31 },
            { response: "Advanced", text: "You know your shots. Let's help you control the game.", icon: "#Advanced", goTo: "StormX" },
        ],
    },
    {
        id: 31,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone.", icon: "#Control", goTo: "RiftX" },
            { response: "Speed", text: "Quick on your feet? We'll match that momentum.", icon: "#Speed", goTo: "Apex" },
        ],
    },
    {
        id: 34,
        Question: "Have you played any other racquet sport before — like tennis, badminton, or squash?",
        Answers: [
            { response: "Yes", text: "Awesome. Your instincts will kick in — now let's match the gear.", icon: "#Yes_other_racket_sports", goTo: 35 },
            { response: "No", text: "No worries. Everyone starts somewhere — let's build from the basics.", icon: "#No_other_racket_sports", goTo: 33 },
        ],
    },
    {
        id: 35,
        Question: "What's your skill level in racket sports you've played before?",
        key: "Skill",
        Answers: [
            { response: "Beginner", text: "Here to learn. We've got your back.", icon: "#Beginner", goTo: 36 },
            { response: "Intermediate", text: "You're getting sharper — let's dial in your gear.", icon: "#Intermediate", goTo: 36 },
            { response: "Advanced", text: "You know your shots. Let's help you control the game.", icon: "#Advanced", goTo: "StormX" },
        ],
    },
    {
        id: 36,
        Question: "What is your preferred game style?",
        key: "Strength",
        Answers: [
            { response: "Speed", text: "Quick on your feet? We'll match that momentum.", icon: "#Speed", goTo: "RiftX" },
            { response: "Control", text: "Precision matters. Let's sharpen your strike zone.", icon: "#Control", goTo: "RiftX" },
        ],
    },
    {
        id: 33,
        Question: "What's motivating you to start playing Table Tennis?",
        Answers: [
            { response: "Looking to play casually", text: "Just here to have fun!", icon: "#Casual_play", goTo: "RiftX" },
            { response: "Serious skills", text: "Ready to invest and level up your game. Let's go!", icon: "#Level_up_intermediate", goTo: "RiftX" },
        ],
    },
]


const productHandles = {
    StrikeBase: "strikebase-fibreglass-pickleball-paddle",
    MaxStrike: "maxstrike-t700-carbon-pickleball-paddle",
    Veloflex: "veloflex-raw-carbon-pickleball-paddle",
    Velo: "veloflex-raw-carbon-pickleball-paddle",
    Aero: "aerofusion-edgeless-carbon-pickleball-paddle",
    AeroFusion: "aerofusion-edgeless-carbon-pickleball-paddle",
    HyperCharge: "hypercharge-raw-carbon-pickleball-paddle",
    UltraVolt_14mm: "ultravolt-carbon-pickleball-paddle",
    UltraVolt_16mm: "ultravolt-carbon-pickleball-paddle",
    Dynamex: "dynamex-12k-carbon-fibre-padel-tennis-racket",
    Equinex: "equinex-3k-carbon-fibre-padel-tennis-racket",
    Kinex: "kinex-carbon-fibre-padel-racket",
    // Table Tennis
    RiftX: "riftx-carbon-table-tennis-racket",
    Apex: "apex-carbon-table-tennis-racket",
    StormX: "stormx-carbon-table-tennis-racket-with-cover",
}


const blogs = [
    {
        id: "padel-playbook",
        title: "Padel Playbook",
        image: "https://cdn.shopify.com/s/files/1/0647/4704/5073/files/banner_1.png?v=1761174276",
        url: "https://firstedgesports.com/blogs/padel-playbook/engineered-to-win-the-best-carbon-fibre-padel-rackets-for-advanced-amp-competitive-players-in-india",
    },
]

window.gamePlay = gamePlay;
window.productHandles = productHandles;
window.blogs = blogs;